<div class="cds-flex cds-flex-col cds-justify-center cds-items-center cds-p-3 cds-gap-2 cds-h-full">
  <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_498_96396)">
      <path
        d="M38.9982 58.5C39.9094 58.5 40.6737 58.1918 41.2912 57.5755C41.9087 56.9591 42.2175 56.1954 42.2175 55.2843C42.2175 54.3731 41.9093 53.6087 41.293 52.9912C40.6766 52.3737 39.9129 52.065 39.0018 52.065C38.0906 52.065 37.3262 52.3732 36.7087 52.9895C36.0912 53.6059 35.7825 54.3696 35.7825 55.2807C35.7825 56.1919 36.0907 56.9562 36.707 57.5737C37.3234 58.1912 38.0871 58.5 38.9982 58.5ZM36.3675 43.5825H42.2175V18.915H36.3675V43.5825ZM39.0259 78C33.6482 78 28.5945 76.9762 23.8647 74.9287C19.1349 72.8812 14.9987 70.0863 11.4562 66.5437C7.91375 63.0012 5.11875 58.8627 3.07125 54.128C1.02375 49.3934 0 44.3345 0 38.9512C0 33.568 1.02375 28.5091 3.07125 23.7745C5.11875 19.0398 7.91375 14.9175 11.4562 11.4075C14.9987 7.8975 19.1373 5.11875 23.872 3.07125C28.6066 1.02375 33.6655 0 39.0487 0C44.432 0 49.4909 1.02375 54.2255 3.07125C58.9602 5.11875 63.0825 7.8975 66.5925 11.4075C70.1025 14.9175 72.8812 19.045 74.9287 23.79C76.9762 28.535 78 33.5964 78 38.9741C78 44.3518 76.9762 49.4055 74.9287 54.1353C72.8812 58.8651 70.1025 62.9953 66.5925 66.5258C63.0825 70.0563 58.955 72.8513 54.21 74.9108C49.465 76.9703 44.4036 78 39.0259 78ZM39.0487 72.15C48.2463 72.15 56.0625 68.9162 62.4975 62.4487C68.9325 55.9812 72.15 48.1488 72.15 38.9512C72.15 29.7537 68.9386 21.9375 62.5158 15.5025C56.093 9.0675 48.2544 5.85 39 5.85C29.835 5.85 22.0187 9.06139 15.5512 15.4842C9.08375 21.907 5.85 29.7456 5.85 39C5.85 48.165 9.08375 55.9812 15.5512 62.4487C22.0187 68.9162 29.8512 72.15 39.0487 72.15Z"
        fill="#6E27C5" />
    </g>
    <defs>
      <clipPath id="clip0_498_96396">
        <rect width="78" height="78" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <h3 class="cds-mt-6 cds-text-center">Policy Number Not Found</h3>
  <p class="body-regular cds-text-center">The policy number you were looking for is not available in the system.</p>
  <div class="cds-flex cds-gap-2 cds-mt-4">
    <button
      cbButton
      label="Return"
      variant="secondary"
      colorTheme="purple"
      data-testid="policy-not-found-back-button"
      (click)="back()"></button>
    <button
      cbButton
      label="Support"
      variant="primary"
      colorTheme="purple"
      data-testid="policy-not-found-support-button"
      (click)="getSupport()"></button>
  </div>
</div>
